const $ = jQuery;
const $window = $(window);

const initSlider = () => {
  const els = once('services-slider', '.p-flat-slider');
  els.forEach((el) => {
    const $wrapper = $(el);
    const $slider = $wrapper.find('.pss-slider');

    // Slick initialization
    $slider.slick({
      slidesToShow: 4,
      dots: true,
      variableWidth: true,
      autoplay: true,
      centerMode: true,
      accessibility: true,
      pauseOnHover: true,
      autoplaySpeed: 3000,
      prevArrow: $wrapper.find('.om-slider-arrow-prev'),
      nextArrow: $wrapper.find('.om-slider-arrow-next'),
      appendDots: $wrapper.find('.om-slider-dots'),
    });
  });
};

$window.on('load', function () {
  initSlider();
});
